import { PlanType } from '@core/models'

import { type TSessionDialogContext, type TSessionDialogVerdict } from '../types/sessionDialogTypes'

export const isFreePlanUser = ({
    isAuthenticated,
    isSessionRefreshing,
    isPlanLoading,
    planType,
}: TSessionDialogContext): TSessionDialogVerdict => {
    if (isSessionRefreshing) {
        return 'pending'
    }

    if (!isAuthenticated) {
        return false
    }

    if (isPlanLoading) {
        return 'pending'
    }

    if (planType && planType !== PlanType.Free) {
        return false
    }

    return true
}
